'use client';

import { useSuspenseQuery } from '@tanstack/react-query';

import { AuthQueryOptions } from '@/api';

//* 출석체크로 증가하는 보유 수량이라, 진입할 때마다 서버와 재동기화한다.
//* (재진입 시 서버 프리페치가 지급 전 수량을 fresh 타임스탬프로 내려 덮어쓰는 stale-clobber 방지.)
export const useLuckyTicketCount = () =>
  useSuspenseQuery({
    ...AuthQueryOptions['get:/wello/v2/auth/benefit-tickets'](),
    refetchOnMount: 'always',
    select: (data) => data?.context?.luckyTicketCount ?? 0,
  });
